export const LOAD_CLAIMS = 'LOAD_CLAIMS';
export const RESET_CLAIMS = 'RESET_CLAIMS';
